import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/SubscriptionPricingCard.css";

const GST_RATE = 0.18; // 18% GST

/**
 * Subscription Pricing Card – Single Page Checkout
 * ₹100 + GST per property per month
 * Shows fee breakup and payment form inline on same page
 * No page redirects - seamless payment experience
 */
const SubscriptionPricingCard = ({ variant = "default", onNavigate, dashboardBasePath = "/seller-dashboard" }) => {
  const navigate = useNavigate();

  // Plan configuration
  const plan = {
    id: "basic_listing",
    name: "Basic Plan",
    basePrice: 100,
    features: [
      "List 1 property for 30 days",
      "Easy property upload and management",
      "Get leads from verified buyers",
      "Reach people across India",
      "Pay only for the properties you list"
    ],
  };

  // Calculate GST (18%)
  const gstAmount = Math.round(plan.basePrice * GST_RATE * 100) / 100;
  const totalPrice = plan.basePrice + gstAmount;

  const handlePayNow = async () => {
    navigate(`${dashboardBasePath}/checkout`, {
      state: {
        planId: plan.id,
      },
    });
  };

  return (
    <div className={`subscription-pricing-card subscription-pricing-card--${variant}`}>
      <div className="subscription-pricing-card__inner">
        <h3 className="subscription-pricing-card__title">
          Property Listing Subscription
        </h3>
        <p className="subscription-pricing-card__message">
          List your property for just{" "}
          <span className="subscription-pricing-card__price">₹{plan.basePrice}</span> per month
          per property <span className="subscription-pricing-card__gst">+ GST</span>
        </p>
        {/* <p className="subscription-pricing-card__highlight">
          Limited to 1 property listing per subscription period
        </p> */}

        <ul className="subscription-pricing-card__features">
  <li>List 1 property for 30 days</li>
  <li>Easy property upload and management</li>
  <li>Get leads from verified buyers</li>
  <li>Reach people across India</li>
  <li>Pay only for the properties you list</li>
</ul>

        {/* Fee Breakup Section */}
        <div className="subscription-pricing-card__fee-breakup">
          <h4 className="fee-breakup-title">Fee Breakup</h4>
          <div className="fee-row">
            <span className="fee-label">Amount</span>
            <span className="fee-value">₹{plan.basePrice.toFixed(2)}</span>
          </div>
          <div className="fee-row">
            <span className="fee-label">Convenience Charges</span>
            <span className="fee-value">₹0.00</span>
          </div>
          <div className="fee-row">
            <span className="fee-label">GST 18%</span>
            <span className="fee-value">₹{gstAmount.toFixed(2)}</span>
          </div>
          <div className="fee-divider"></div>
          <div className="fee-row fee-total">
            <span className="fee-label">Total Charges</span>
            <span className="fee-value">₹{totalPrice.toFixed(2)}</span>
          </div>
        </div>

        {/* Pay Now Button - Only Button */}
        <button
          className="subscription-pricing-card__cta pay-now-btn"
          onClick={handlePayNow}
        >
          Continue to Checkout
        </button>

        <p className="subscription-pricing-card__note">
          Tax and place of supply will be selected on the next step.
        </p>
      </div>

    </div>
  );
};

export default SubscriptionPricingCard;
